<template>
    <div class="score-widget">
        <div class="fill" :style="background"></div>
        <div class="score"></div>
        <div class="display">
            {{text}}
        </div>
    </div>
</template>
<script type="text/javascript">
export default {
    props: {
        score: Number,
        text: String
    },
    data: function () {
        return {
            background: ''
        }
    },
    created() {
        let color = this.getColor();
        let percentage = (this.score*100);
        this.background = 'background: conic-gradient(' + color + ' ' + percentage + '%, transparent 0 100%);';
    },
    methods: {
        getColor() {
            if(this.score > 0.75) {
                return 'green';
            }
            if(this.score > 0.50) {
                return 'yellow';
            }
            if(this.score > 0.25) {
                return 'orange';
            }

            return 'red';
        }

    }
}
</script>
